var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmptyIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 10,
    viewBox: "0 0 12 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.38039 0.51302C6.18596 0.177953 5.70209 0.177951 5.50766 0.513019L4.13841 2.87274C4.04236 3.03826 3.87636 3.15122 3.68714 3.1798L1.12107 3.56737C0.690078 3.63247 0.538899 4.17663 0.874548 4.45471L2.78616 6.03846C2.96311 6.18507 3.04632 6.41631 3.00333 6.64205L2.50328 9.26806C2.42423 9.68319 2.86002 10.0057 3.23393 9.80884L5.65021 8.53657C5.83412 8.43973 6.05393 8.43973 6.23784 8.53657L8.65411 9.80884C9.02803 10.0057 9.46381 9.68319 9.38476 9.26806L8.88472 6.64205C8.84173 6.41631 8.92493 6.18507 9.10188 6.03846L11.0135 4.45471C11.3491 4.17663 11.198 3.63247 10.767 3.56737L8.20091 3.1798C8.01169 3.15122 7.84568 3.03826 7.74964 2.87274L6.38039 0.51302Z",
    fill: "#FFE7C0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyIcon);
export default __webpack_public_path__ + "static/media/emptyIcon.c80549d569f25d828e1f0daf74004015.svg";
export { ForwardRef as ReactComponent };